var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMobileMenu = function SvgMobileMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .935)",
    fill: "currentcolor",
    fillRule: "nonzero",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 22,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 22,
    height: 2,
    rx: 1
  }))));
};

export default SvgMobileMenu;